export const getIsMatchingText = (cell) => {
  if (cell.column.id === "isMatching") {
    if (cell.value === null) return "-";
    return cell.value ? "Da" : "Ne";
  }
  return cell.value ?? "-";
};
